/*
 * @Author: WLL
 * @Date: 2020-04-18 18:20:48
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-09 14:08:13
 * @Description: 常量数据文件
 */
export const timeRangeList = [
  {
    label: "近1个月",
    value: 1
  },
  {
    label: "近3个月",
    value: 3
  },
  {
    label: "近6个月",
    value: 6
  },
  {
    label: "近1年",
    value: 12
  }
];

export const timeRangeStartThreeList = [
  {
    label: "近3个月",
    value: 3
  },
  {
    label: "近6个月",
    value: 6
  },
  {
    label: "近1年",
    value: 12
  }
];

export const averageReturnList = [
  {
    label: "全部",
    value: "all"
  },
  {
    label: "≥50%",
    value: "50%"
  },
  {
    label: "≥25%",
    value: "25%"
  },
  {
    label: "≥20%",
    value: "20%"
  },
  {
    label: "≥15%",
    value: "15%"
  },
  {
    label: "≥10%",
    value: "10%"
  }
];

export const industryTimeRangeList = [
  {
    label: "近1个月",
    value: 1
  },
  {
    label: "近3个月",
    value: 3
  },
  {
    label: "近6个月",
    value: 6
  }
];

export const pageList = [
  {
    label: "1-5页",
    value: "1-5"
  },
  {
    label: "6-20页",
    value: "6-20"
  },
  {
    label: "20页以上",
    value: "21"
  }
];

export const gradeList = [
  {
    label: "买入",
    value: "买入"
  },
  {
    label: "增持",
    value: "增持"
  },
  {
    label: "中性",
    value: "中性"
  },
  {
    label: "减持",
    value: "减持"
  },
  {
    label: "卖出",
    value: "卖出"
  }
];

export const gradeChangeList = [
  {
    label: "调高",
    value: "调高"
  },
  {
    label: "调低",
    value: "调低"
  },
  {
    label: "首次",
    value: "首次"
  },
  {
    label: "维持",
    value: "维持"
  }
];
